import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";

const PageMentions = ({ block }) => {

    if (!block) return null;

    return (
        <div className="c-page__block c-page__block--mentions">
            <div className="c-mentions">
                <div className="l-grid">
                    <div className="l-grid__col">
                        {block.heading &&
                            <h3 className="c-mentions__heading" dangerouslySetInnerHTML={{ __html: block.heading }}></h3>
                    }
                        <div className="c-mentions__table">
                            {block.mentions.map((mention, index) => (
                                <div className="c-mentions__row" key={index}>
                                    {mention.url &&
                                        <a href={mention.url} target="_blank" rel="noopener noreferrer" className="c-mentions__row__inner c-mentions__row__inner--link">
                                            {mention.label && <span className="c-mentions__label">{mention.label}</span>}
                                            {mention.project && <span className="c-mentions__project">{mention.project}</span>}
                                            {mention.year && <span className="c-mentions__year">{mention.year}</span>}
                                        </a>
                                    }
                                    {!mention.url &&
                                        <div className="c-mentions__row__inner">
                                            {mention.label && <span className="c-mentions__label">{mention.label}</span>}
                                            {mention.project && <span className="c-mentions__project">{mention.project}</span>}
                                            {mention.year && <span className="c-mentions__year">{mention.year}</span>}
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageMentions;
